import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[asc-loading]',
})
export class LoadingDirective implements OnInit {
  span: HTMLElement;
  parent: HTMLElement;

  interval: number;
  @Input() set showLoading(val: boolean) {
    if (val) {
      this.setTimer();
    } else {
      this.clearTimer();
    }
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.createElement();
  }

  ngOnInit(): void {}

  private setTimer(): void {
    this.interval = window.setInterval(() => {
      if (this.span.innerHTML.length > 2) {
        this.span.innerHTML = '';
      } else {
        this.span.innerHTML += '.';
      }
    }, 500);
  }

  private clearTimer(): void {
    clearInterval(this.interval);
    this.span.innerHTML = '';
    this.parent.innerHTML = '';
  }

  private createElement(): void {
    this.span = this.renderer.createElement('span');
    this.parent = this.elementRef.nativeElement;
    this.setStyles(this.parent);
    this.setStyles(this.span);
    this.parent.innerHTML = 'Loading';
    this.renderer.insertBefore(
      this.parent.parentElement,
      this.span,
      this.renderer.nextSibling(parent)
    );
  }

  private setStyles(parent): void {
    this.renderer.setStyle(parent, 'color', '#7a7a7a');
    this.renderer.setStyle(parent, 'font-size', '1.2rem');
    this.renderer.setStyle(parent, 'font-weight', '600');
    this.renderer.setStyle(parent, 'height', '100%');
  }
}
